import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/treatment-categories'],
  validationMode: 'any',
};

export const treatmentCategoriesStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.TreatmentCategories,
  category: PracticeSetupStepCategory.ConditionsAndTreatments,
  title: 'Review and Configure Treatment Categories',
  description: initRawSchema(
    `Treatment Categories will dictate the colour of appointments on the timeline and can also aid in reporting. Review the default categories and colours, add and remove any as needed.`
  ),
  dependsOn: [],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/treatment-categories`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason:
            'Please review and approve all treatment categories before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
